<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" fill="none" stroke="black">
    <path d="M6 10L12 16L18 10" stroke-width="1.5" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  size?: 'small' | 'medium' | 'large'
}>()

const size = computed<string>(() => {
  switch (props.size) {
    case 'small':
      return '16'
    case 'medium':
      return '24'
    case 'large':
      return '32'
    default:
      return '24'
  }
})
</script>
